module.exports = __webpack_public_path__ + "static/media/datavase_article_eyecatching.ac6aa07f.png";